/** Mirrors backend sellix.security.valid_password — keep in sync. */
export function isValidPassword(pw) {
  if (!pw || pw.length < 10) return false;
  const classes = [
    /[a-z]/.test(pw),
    /[A-Z]/.test(pw),
    /\d/.test(pw),
    /[^A-Za-z0-9]/.test(pw),
  ];
  return classes.filter(Boolean).length >= 3;
}

export const PASSWORD_POLICY_MESSAGE =
  "Password must be ≥10 chars with 3 of 4 character classes";
